import { LEGACY_PATH_REDIRECTS, findDestinationByPath, userCanAccessDestination, visibleInThisBuild } from '@/navigation/registry';

export interface AuthReturnLocation { pathname?: string; search?: string; hash?: string }

export function explicitAuthReturnPath(from?: AuthReturnLocation): string | null {
  const path = from?.pathname;
  if (!path || !path.startsWith('/') || path.startsWith('//') || path.includes('\\') || Array.from(path).some((character) => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127) || /^\/(auth|api)(\/|$)/.test(path)) return null;
  return `${path}${from.search?.startsWith('?') ? from.search : ''}${from.hash?.startsWith('#') ? from.hash : ''}`;
}

export function preferredPostSignInPath(preferred: string | null | undefined, permissions: readonly string[]): string {
  if (!preferred || !preferred.startsWith('/') || preferred.startsWith('//')) return '/';
  // A page that moved (e.g. /clients -> /crm/clients) keeps working as a saved landing page.
  const canonical = LEGACY_PATH_REDIRECTS[preferred] ?? preferred;
  const destination = findDestinationByPath(preferred);
  return destination && destination.path === canonical && visibleInThisBuild([destination.id]).length > 0 && userCanAccessDestination(destination, permissions) ? destination.path : '/';
}
